import { getAPIErrorCode } from '@vizit/api';

/** What Spark tells the user when the API can't run it on an image yet. */
export const SPARK_NOT_READY_MESSAGE = "Spark isn't available for this image yet. Check back soon.";

/**
 * What the API answers when it can't run Spark on an image yet though the image has a score: a hero without GS1
 * scores under the GS1 pipeline, or an image without a product category. Both happen to images only a collection's
 * custom pair scored. Expected, so not an error to report, and asking again gets the same answer.
 */
const SPARK_NOT_READY_ERROR_CODES = new Set(['HERO_GS1_SCORES_MISSING', 'MISSING_PRODUCT_CATEGORY']);

export function isSparkNotReadyError(error: unknown): boolean {
  return SPARK_NOT_READY_ERROR_CODES.has(getAPIErrorCode(error) ?? '');
}
